/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Concierge_Is_DisabledInputs */

const en_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Concierge is Disabled`)
};

const es_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El conserje IA está desactivado`)
};

const fr_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le concierge IA est désactivé`)
};

const de_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Concierge ist deaktiviert`)
};

const ja_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIコンシェルジュは無効です`)
};

const zh_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 礼宾客服已禁用`)
};

const ar_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المساعد الذكي معطل`)
};

const id_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pramutamu AI Dinonaktifkan`)
};

const it_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Concierge IA è Disabilitato`)
};

const ru_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-Консьерж отключен`)
};

const pt_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA está Desativado`)
};

const ko_ai_concierge_is_disabled = /** @type {(inputs: Ai_Concierge_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 컨시어지가 비활성화되었습니다`)
};

/**
* | output |
* | --- |
* | "AI Concierge is Disabled" |
*
* @param {Ai_Concierge_Is_DisabledInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_concierge_is_disabled = /** @type {((inputs?: Ai_Concierge_Is_DisabledInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Concierge_Is_DisabledInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_concierge_is_disabled(inputs)
	if (locale === "es") return es_ai_concierge_is_disabled(inputs)
	if (locale === "fr") return fr_ai_concierge_is_disabled(inputs)
	if (locale === "de") return de_ai_concierge_is_disabled(inputs)
	if (locale === "ja") return ja_ai_concierge_is_disabled(inputs)
	if (locale === "zh") return zh_ai_concierge_is_disabled(inputs)
	if (locale === "ar") return ar_ai_concierge_is_disabled(inputs)
	if (locale === "id") return id_ai_concierge_is_disabled(inputs)
	if (locale === "it") return it_ai_concierge_is_disabled(inputs)
	if (locale === "ru") return ru_ai_concierge_is_disabled(inputs)
	if (locale === "pt") return pt_ai_concierge_is_disabled(inputs)
	return ko_ai_concierge_is_disabled(inputs)
});